// Avatar con iniciales y gradient HSL determinista por nombre.

export default function Avatar({ name = '', size = 28, hue = null, src = null, className = '' }) {
  const initials = name.split(' ').map(s => s[0]).filter(Boolean).slice(0, 2).join('').toUpperCase() || '?'
  const h = hue ?? Math.abs(name.split('').reduce((a, c) => a + c.charCodeAt(0), 0)) % 360

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={`rounded-full object-cover ${className}`}
        style={{ width: size, height: size }}
      />
    )
  }

  return (
    <span
      className={`inline-grid place-items-center rounded-full text-white font-semibold tnum ${className}`}
      style={{
        width: size,
        height: size,
        background: `linear-gradient(135deg, hsl(${h} 70% 52%), hsl(${(h + 50) % 360} 70% 42%))`,
        fontSize: size * 0.36,
      }}
      aria-hidden="true"
    >
      {initials}
    </span>
  )
}
